import type { EnvironmentUtils } from '@change-corgi/core/environment';
import type { ErrorReporter } from '@change-corgi/core/errorReporter/common';
import type { GqlClient } from '@change-corgi/core/gql';
import { createGqlClient as _createGqlClient } from '@change-corgi/core/gql';

import webappInfo from '#src/webappInfo';

import { wrapFetchForPerimeterX } from './shared/perimeterX';

type Options = Readonly<{
	errorReporter: ErrorReporter;
	environment: EnvironmentUtils;
}>;

export function createGqlClient({ errorReporter, environment }: Options): GqlClient {
	return _createGqlClient({
		uri: '/api-proxy/graphql',
		fetch: environment.getEnvironment() === 'production' ? undefined : wrapFetchForPerimeterX(),
		webappInfo,
		errorReporter,
		networkErrorReporter: errorReporter.child({ sampleRate: 0.01 }),
		headers: {
			accept: 'application/json',
			'x-requested-with': `corgi-front-end-browser:${webappInfo.version}`,
		},
		addOperationNamesToUri: true,
	});
}
